/**
 * 商品列表接口
 */
export default {
  BASE_URL: '/mm/storeManage',
  api: [
    {
      name: 'getPayMethods',
      desc: '加载结算方式',
      method: 'GET',
      path: '/getPayMethods'
    },
    {
      name: 'getPayTypes',
      desc: '加载结算类型',
      method: 'GET',
      path: '/getPayTypes'
    },
    {
      name: 'getSobStoreInfo',
      desc: '获取店铺信息',
      method: 'GET',
      path: '/getSobStoreInfo'
    },
    {
      name: 'saveSobStoreInfo',
      desc: '保存店铺信息',
      method: 'POST',
      path: '/saveSobStoreInfo'
    },
    {
      name: 'findSalesman',
      desc: '业务员窗口',
      method: 'GET',
      path: '/findSalesman'
    },
    {
      name: 'getSalesman',
      desc: '业务员下拉框',
      method: 'GET',
      path: '/getSalesman'
    },
    {
      name: 'checkCanDelSalesman',
      desc: '校验是否能删除业务员',
      method: 'GET',
      path: '/checkCanDelSalesman'
    },
    {
      name: 'delPayMethod',
      desc: '校验结算方式是否可以删除',
      method: 'POST',
      path: '/delPayMethod'
    },
    {
      name: 'delSalesman',
      desc: '校验业务员多个是否可以删除',
      method: 'POST',
      path: '/delSalesman'
    },
    {
      name: 'delStore',
      desc: '校验店铺是否可以删除',
      method: 'POST',
      path: '/delStore'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/store.js